import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, BookOpen, Clock, Landmark, ShieldCheck, Globe2 } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#09090b] text-white mt-16" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2 space-y-4">
          <div className="flex items-center gap-3">
            <div className="relative w-12 h-12 shrink-0">
              <div className="absolute inset-0 rounded-full bg-[#facc15] opacity-30 blur-md" aria-hidden />
              <img
                src="https://customer-assets.emergentagent.com/job_priya-book-platform/artifacts/j5n2tcp1_IMG_20211220_171122.jpg"
                alt="GAINA THE PRELUDE"
                className="relative w-full h-full rounded-full object-cover ring-2 ring-[#facc15]"
              />
            </div>
            <div>
              <div className="font-display text-xl font-black">GAINA THE PRELUDE</div>
            </div>
          </div>
          <p className="text-sm text-[#a1a1aa] max-w-md leading-relaxed">
            A curated books distributor for every kind of reader — <span className="italic text-[#fb923c]">"where every genre finds its readers"</span>. Your next story is just a click away. The smart way to shop books online.
          </p>
          <div className="pt-4 flex flex-col gap-2">
            <a href="tel:9953272630" className="inline-flex items-center gap-3 text-[#fb923c] font-bold text-lg" data-testid="footer-phone">
              <Phone className="w-4 h-4" /> +91 99532 72630
            </a>
            <a href="mailto:gainatheprelude@gmail.com" className="inline-flex items-center gap-3 text-sm text-[#d4d4d8]" data-testid="footer-email">
              <Mail className="w-4 h-4" /> gainatheprelude@gmail.com
            </a>
            <div className="inline-flex items-center gap-3 text-sm text-[#d4d4d8]">
              <MapPin className="w-4 h-4" /> New Delhi, India
            </div>
            <div className="mt-3 pt-3 border-t border-[#27272a] max-w-md" data-testid="footer-open-hours">
              <div className="text-[10px] font-bold tracking-[0.2em] uppercase text-[#fb923c] mb-1.5 inline-flex items-center gap-1.5">
                <Clock className="w-3 h-3" /> Open Hours
              </div>
              <div className="text-sm text-[#d4d4d8] font-semibold">Monday to Friday · 10:00 AM – 6:00 PM</div>
              <div className="text-sm text-[#71717a] mt-0.5">Saturday &amp; Sunday · Closed</div>
            </div>
          </div>
        </div>

        <div>
          <div className="font-display font-bold text-xs tracking-[0.2em] uppercase text-[#fb923c] mb-4">Shop</div>
          <ul className="space-y-2 text-sm text-[#d4d4d8]">
            <li><Link to="/books" className="hover:text-white">All Books</Link></li>
            <li><Link to="/categories" className="hover:text-white">All Categories</Link></li>
            <li><Link to="/books?new_arrival=true" className="hover:text-white">✨ New Arrivals</Link></li>
            <li><Link to="/books?category=History" className="hover:text-white">History</Link></li>
            <li><Link to="/books?category=Art and Archaeology" className="hover:text-white">Art &amp; Archaeology</Link></li>
            <li><Link to="/books?category=Biography and Autobiography" className="hover:text-white">Biography</Link></li>
            <li><Link to="/books?category=Civil Engineering" className="hover:text-white">Engineering</Link></li>
            <li><Link to="/books?category=Engineering" className="hover:text-white">Engineering</Link></li>
            <li><Link to="/books?category=Old and Rare Books" className="hover:text-white">Old &amp; Rare Books</Link></li>
          </ul>
        </div>

        <div>
          <div className="font-display font-bold text-xs tracking-[0.2em] uppercase text-[#fb923c] mb-4">Account</div>
          <ul className="space-y-2 text-sm text-[#d4d4d8]">
            <li><Link to="/orders" className="hover:text-white">My Orders</Link></li>
            <li><Link to="/cart" className="hover:text-white">Cart</Link></li>
            <li><Link to="/return-policy" className="hover:text-white" data-testid="footer-return-policy-link">Return Policy</Link></li>
            <li><Link to="/shipping-policy" className="hover:text-white" data-testid="footer-shipping-policy-link">Shipping &amp; Delivery</Link></li>
            <li><Link to="/payment-options" className="hover:text-white" data-testid="footer-payment-options-link">Payment Options</Link></li>
            <li><Link to="/about" className="hover:text-white" data-testid="footer-about-link">About Us</Link></li>
            <li><Link to="/values" className="hover:text-white" data-testid="footer-values-link">Goals &amp; Values</Link></li>
            <li><Link to="/disclaimer" className="hover:text-white" data-testid="footer-disclaimer-link">Disclaimer</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#27272a] bg-[#0a0a0a]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-testid="footer-trust-section">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            {/* Trust Badges + Payment Modes */}
            <div className="flex flex-col gap-3" data-testid="footer-trust-badges">
              <div className="text-[10px] font-bold tracking-[0.2em] uppercase text-[#fb923c]">Accepted Payments</div>
              <div className="flex flex-wrap items-center gap-2">
                {/* PayPal */}
                <div
                  className="h-8 px-3 rounded-md bg-white flex items-center justify-center shadow-sm ring-1 ring-black/10"
                  data-testid="badge-paypal"
                  aria-label="PayPal"
                >
                  <span className="text-[13px] font-black tracking-tight leading-none">
                    <span className="text-[#003087]">Pay</span><span className="text-[#009cde]">Pal</span>
                  </span>
                </div>
                {/* Visa */}
                <div
                  className="h-8 px-3 rounded-md bg-white flex items-center justify-center shadow-sm ring-1 ring-black/10"
                  data-testid="badge-visa"
                  aria-label="Visa"
                >
                  <span className="italic font-black text-[15px] leading-none text-[#1a1f71] tracking-wider">VISA</span>
                </div>
                {/* Mastercard */}
                <div
                  className="h-8 px-3 rounded-md bg-white flex items-center gap-1 shadow-sm ring-1 ring-black/10"
                  data-testid="badge-mastercard"
                  aria-label="Mastercard"
                >
                  <span className="relative flex items-center leading-none">
                    <span className="w-4 h-4 rounded-full bg-[#eb001b] block" />
                    <span className="w-4 h-4 rounded-full bg-[#f79e1b] block -ml-2 mix-blend-multiply" />
                  </span>
                  <span className="text-[9px] font-bold uppercase text-[#1a1a1a] tracking-wide leading-none whitespace-nowrap">Mastercard</span>
                </div>
                {/* American Express */}
                <div
                  className="h-8 px-3 rounded-md bg-[#2e77bb] flex items-center justify-center shadow-sm ring-1 ring-black/10"
                  data-testid="badge-amex"
                  aria-label="American Express"
                >
                  <span className="text-white text-[10px] font-black uppercase tracking-tight leading-tight text-center">AMERICAN<br/>EXPRESS</span>
                </div>
                {/* Bank Wire */}
                <div
                  className="h-8 px-3 rounded-md bg-white flex items-center gap-1.5 shadow-sm ring-1 ring-black/10"
                  data-testid="badge-bank-wire"
                  aria-label="Bank Wire"
                >
                  <Landmark className="w-3.5 h-3.5 text-[#065f46]" />
                  <span className="text-[11px] font-black uppercase text-[#065f46] leading-none tracking-tight">Bank Wire</span>
                </div>
              </div>
            </div>

            {/* SSL Shield */}
            <div
              className="flex items-center gap-3 px-4 py-2.5 rounded-lg bg-gradient-to-r from-[#052e16] to-[#064e3b] ring-1 ring-[#10b981]/40"
              data-testid="footer-ssl-shield"
            >
              <ShieldCheck className="w-7 h-7 text-[#34d399] shrink-0" />
              <div className="leading-tight">
                <div className="text-[10px] font-bold tracking-[0.18em] uppercase text-[#34d399]">Secure SSL</div>
                <div className="text-sm font-black text-white">100% Safe Payments</div>
              </div>
            </div>
          </div>

          {/* Important Notice */}
          <div
            className="mt-6 pt-5 border-t border-[#27272a] flex items-start md:items-center gap-2 text-[#d4d4d8]"
            data-testid="footer-payment-notice"
          >
            <Globe2 className="w-4 h-4 shrink-0 text-[#fb923c] mt-0.5 md:mt-0" />
            <p className="text-xs md:text-sm leading-relaxed">
              We accept global payments in <span className="font-bold text-white">USD ($)</span> via <span className="font-bold text-white">PayPal</span> and <span className="font-bold text-white">Bank Wire</span>. <span className="text-[#fb923c] font-bold">Worldwide Shipping Available.</span>
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-[#27272a]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between text-xs text-[#71717a]">
          <div>© {new Date().getFullYear()} GAINA THE PRELUDE. All rights reserved.</div>
          <div className="mt-2 md:mt-0">Bulk Orders • Institutional Supply • Worldwide Shipping</div>
        </div>
      </div>
    </footer>
  );
}
